import { GetAppListener } from "@shared/models/redux";
import { changeInvestorAccountsGroup } from "@user/store/thunks/changeInvestorAccountsGroup";
import RouterUtils from "@shared/utils/RouterUtils";
import { AppRoute } from "@app/models/AppRoute";
import { resetState } from "@scheduleOfInvestments/store/ducks";
import { initScheduleOfInvestments } from "@scheduleOfInvestments/store/thunks";

export const getIAGroupChangedSOIListener: GetAppListener = (addAppListener, { history }) =>
  addAppListener({
    actionCreator: changeInvestorAccountsGroup.fulfilled,
    effect: (_action, { dispatch, cancelActiveListeners }) => {
      cancelActiveListeners();

      dispatch(resetState());

      if (RouterUtils.checkPathMatchExactRoute(history, AppRoute.ScheduleOfInvestments)) {
        dispatch(initScheduleOfInvestments());
      }
    },
  });
